import axios from "axios";
const MAPS_KEY = "importedMaps";
export function getOrCreateLocalStorageMaps() {
  const mapsJsonStr = window.localStorage.getItem(MAPS_KEY);

  let maps = [];
  if (mapsJsonStr) {
    maps = JSON.parse(mapsJsonStr).map((m) => ({...m, added_to_map: false}));
  } else {
    window.localStorage.setItem(MAPS_KEY, JSON.stringify(maps));
  }
  return maps;
}
function addMap2LocalStorage(map) {
  const maps = getOrCreateLocalStorageMaps();
  const exist = maps.find((m) => m.name === map.name);
  if (!exist) {
    maps.push(map);
  }
  window.localStorage.setItem(MAPS_KEY, JSON.stringify(maps));
}
export function deleteMap(context,map) {
  context.commit("deleteMap",map)
}

export function testConnection(context, mapUrl) {
  return axios({
    method: "get",
    baseURL: "",
    url: mapUrl,
  }).catch(function (error) {
    console.log(error);
  });
}
export function load(context) {
  const maps = getOrCreateLocalStorageMaps();
  context.commit("setMaps", maps);
}
//导入外部地图
export function importMap(context, map) {
  context.commit("importMap", map);
  addMap2LocalStorage(map);
}

//发布图层到球
export function addToEarth({commit,state}, map) {
  commit("addToEarth", map);
  const addedMap = state.addedList.find((m) => m.name === map.name);
  if (addedMap) {
    commit("maps/addToOrderList", addedMap, {root: true})
  }
}

//删除图层
export function removeFromEarth({commit}, map) {
  commit("removeFromEarth", map);
  commit("maps/removeFromOrderList",map.id,{root: true})
}
